<div class="card bg-light">
    <div class="card-header bg-style">
        <button class="mobile-btn" (click)="goToMenu()">
            <img ngSrc="/assets/img/icons/submenu.svg"
                 priority="true" width="24" height="24" alt=""/>
        </button>
        <div class="card-header-content">
            <img class="card-icon" ngSrc="{{icon}}" width="72" height="72" alt=""/>
            <div class="card-title color-light font-22 font-bold">
                {{ title }}
            </div>
        </div>
    </div>
    <div class="card-content">
        <ng-content></ng-content>
    </div>
</div>
